import React from "react";
import { cn } from "../../../common/u1/cn";
import { DocumentIcon } from "../../../../assets/ui/icons";
import { ProfileCard } from "./ProfilePrimitives";

/* Tab 04 — Documents. TRANSCRIBED from tab3Content/SupportingDocs: the same three documents, read off the same three fields, each opening in a new tab. A... */
export const SUPPORTING_DOCUMENTS = [
  { key: "MOA", title: "Memorandum of Association" },
  { key: "VAT_certificate", title: "VAT Certificate" },
  { key: "trade_license", title: "Trade License" },
];

export const documentRows = (company) =>
  SUPPORTING_DOCUMENTS.map((doc) => ({ ...doc, url: company?.[doc.key] })).filter(
    (doc) => doc.url
  );

/* The file's kind, from its extension — the design's chip. Unknown or
   extensionless URLs get no chip rather than a wrong one. */
export const fileKind = (url) => {
  const match = String(url || "")
    .split("?")[0]
    .match(/\.([a-z0-9]{2,5})$/i);
  return match ? match[1].toUpperCase() : null;
};

export const DocumentCard = ({ title, url }) => {
  const kind = fileKind(url);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "group relative flex min-h-[150px] flex-col justify-between overflow-hidden rounded-[14px]",
        "bg-[image:var(--doc-grad)] p-5 text-white",
        "transition-transform duration-200 hover:-translate-y-0.5",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)] focus-visible:ring-offset-2"
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <span
          aria-hidden="true"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10"
        >
          <DocumentIcon size={22} />
        </span>
        {kind && (
          <span className="shrink-0 rounded bg-[var(--coral)] px-2 py-1 text-[10px] font-bold tracking-[.04em] font-sans">
            {kind}
          </span>
        )}
      </div>

      <div className="mt-6 min-w-0">
        <p className="m-0 text-[16px] font-bold leading-[1.3] font-sans">{title}</p>
        <p className="mt-1 mb-0 text-[12.5px] text-white/70 font-sans">Click to view</p>
      </div>
    </a>
  );
};

export const DocumentsTab = ({ company }) => {
  const documents = documentRows(company);

  if (documents.length === 0) {
    return (
      <ProfileCard>
        <p className="m-0 py-8 text-center text-[14px] text-[var(--muted)] font-sans">
          No supporting documents on file for this business yet.
        </p>
      </ProfileCard>
    );
  }

  return (
    <ProfileCard
      title="Supporting Documents"
      action={
        <span className="text-[13px] text-[var(--muted)] font-sans">
          {documents.length} {documents.length === 1 ? "document" : "documents"}
        </span>
      }
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {documents.map((doc) => (
          <DocumentCard key={doc.key} title={doc.title} url={doc.url} />
        ))}
      </div>
    </ProfileCard>
  );
};

export default DocumentsTab;
